import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../Translations';
import ModalStore from '../../../../../../../../Modal/Store';
import { SchoolPartnerResource } from '../../../../../../../Types';

interface Props {
  experiencesSchoolPartners: Array<SchoolPartnerResource>;
  modalStore: ModalStore;
}

const LeadingInstitutions: React.FC<Props> = ({ experiencesSchoolPartners, modalStore }) => (
  <div className="pr-4">
    <h3 className="text-gray-700 text-sm whitespace-nowrap">
      <T kind="School Partners" />
    </h3>
    <div
      className="flex flex-wrap text-teal-600 font-semibold text-lg"
      onClick={modalStore.open}
      data-intercom-target="learning-design-count"
    >
      {experiencesSchoolPartners.length}
    </div>
  </div>
);

export default observer(LeadingInstitutions);
